import type { ChartSlice } from '../../contracts'
import { AllocationDonut } from './AllocationDonut'

interface AllocationComparisonProps {
  before: ChartSlice[]
  after: ChartSlice[]
  provisional?: boolean
  provisionalReason?: string | null
}

export function AllocationComparison({
  before,
  after,
  provisional,
  provisionalReason,
}: AllocationComparisonProps) {
  return (
    <div className="allocation-comparison">
      <div className="allocation-comparison__pair">
        <div className="allocation-comparison__column">
          <AllocationDonut title="Current allocation" slices={before} />
        </div>
        <div className="allocation-comparison__column">
          <AllocationDonut title="Proposed allocation" slices={after} />
          {provisional ? (
            <p className="allocation-comparison__pill">
              <span className="pill">Provisional</span>
              <small className="muted">
                {provisionalReason || 'Final allocation depends on profile refresh.'}
              </small>
            </p>
          ) : null}
        </div>
      </div>
    </div>
  )
}
